import styled from 'styled-components'
import { layout, typography, color, background, space } from 'styled-system'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { A, P, Image, LinkCard } from 'components/generic/HomePageComponents'
import { respondTo } from 'utils/themeUtils'


// TODO Built variants of base button rather than overwriting styles
const Button = styled(A)`
  transition: background-color 0.5s ease;
  font-weight: bold;
  white-space: normal;
  text-decoration: none;
  background-color: ${(props) => props.theme.colors.inverseColor};
  color: ${(props) => props.theme.colors.buttonColor};
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.inverseColor};
    border-color: ${(props) => props.theme.colors.inverseColor};
  }
`
export const HeroButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.white};
  border: 2px solid;
  border-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.inverseColor};
  font-size: 16px;
  margin-top: 35px;
  min-width: 0px;
  padding: 10px 25px;
  width: 85%;

  :hover {
    background-color: ${(props) => props.theme.colors.inverseColor};
    color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.white};
  }

  ${respondTo.desktop`
    box-shadow: 0 1px 5px rgba(0,0,0,0.4);
    color: ${(props) => props.theme.colors.textColor};
    padding: 8px 32px 5px;
  `}
  ${typography}
`
export const DarkButton = styled(Button)`
  white-space: nowrap;
  :hover {
    background-color: ${(props) => props.theme.colors.secondary};
    border-color: ${(props) => props.theme.colors.inverseColor};
    color: ${(props) => props.theme.colors.white};
  }
`
export const CareguideButton = styled(A)`
  transition: background-color 0.5s ease;
  background-color: ${(props) => props.theme.colors.textColor};
  color: ${(props) => props.theme.colors.white};
  border-radius: 5px;
  padding: 8px 25px;
  margin-bottom: 50px;
  text-decoration: none;
  font-size: 20px;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
`
export const TransitionImage = styled(LazyLoadImage)`
  ${layout}
  transition: transform 0.3s ease;
  transform: translate(0px);

  :hover {
    transform: translate(0px, -20px);
  }
`
export const ProfileImage = styled(LazyLoadImage)`
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`
export const InlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 700px) {
    display: inline;
    text-align: center;
  }
`

export const HeroSubtitle = styled(P)`
${typography}
  a {
    color: ${(props) => props.theme.colors.white};
    font-weight: bold;
    font-size: 14px;

    ${respondTo.desktop`
      font-size: 18px;
    `}
  }
`
export const PWithStylizedSpan = styled(P)`
  span {
    color: ${(props) => props.theme.colors.inverseColor};
  }
`
export const ValuePropStylizedP = styled(P)`
  a {
    color: ${(props) => props.theme.colors.inverseColor};
  }
`

export const FeaturedProfilesImage = styled(LazyLoadImage)`
  margin-top: 30px;
  width: 100%;
  height: 164px;
  opacity: 0.65;
`

export const StyledProfileCard = styled(LinkCard)`
  flex-direction: column;
  width: 225px;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px ${(props) => props.theme.colors.grey} solid;
  background: white;
  margin: 0 0 auto 30px;
  ${layout}
  ${space}
`

export const AdContainerDiv = styled.div`
  display: flex;
  align-self: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.white};
  ${layout}
  ${space}
  div:empty {
    display: none;
    width: 0;
    height: 0;
  }
`